export const messages = {
  en: {
    printSmallOrder: {
      shopName: 'Shop Name',
      orderId: 'Order No',
      createTime: 'Time',
      productName: 'Product',
      quantity: 'Qty',
      price: 'Price',
      amount: 'Amount',
      totalQuantity: 'Total Qty',
      paymentAmount: 'Payment',
      discountAmount: 'Discount',
      printBtn: 'Print',
      cloudPrintBtn: 'Cloud Print',
      cancelBtn: 'Cancel'
    }
  },
  zh: {
    printSmallOrder: {
      shopName: '店铺名称',
      orderId: '单号',
      createTime: '时间',
      productName: '品名',
      quantity: '数量',
      price: '单价',
      amount: '金额',
      totalQuantity: '总数量',
      paymentAmount: '支付金额',
      discountAmount: '优惠金额',
      printBtn: '打印',
      cloudPrintBtn: '云打印',
      cancelBtn: '取消'
    }
  }
}